"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var NeutralDivider_1 = __importDefault(require("atomicComponents/atoms/Divider/NeutralDivider"));
var CategoryTitle_1 = __importDefault(require("containers/Navbar/styles/CategoryTitle"));
var DropdownGroup = function (_a) {
    var categoryTitle = _a.categoryTitle, hideDivider = _a.hideDivider, children = _a.children;
    return ( // todo: Merge with MenuGroup
    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CategoryTitle_1.default, __assign({ px: 2, py: 1 }, { children: categoryTitle })), children, !hideDivider && (0, jsx_runtime_1.jsx)(NeutralDivider_1.default, {})] }));
};
exports.default = DropdownGroup;
